namespace GeniuzPOS.Administration {
    export class PsPosScreenTypeColumns {
        static columnsKey = 'Administration.PsPosScreenType';
    }
}
